__turbopack_context__.v({
  "container": "JKayna_container",
  "content": "JKayna_content",
  "error": "JKayna_error",
  "header": "JKayna_header",
  "processing": "JKayna_processing",
});
